import { getDestinations } from './api'
import { addPhotosToDestination, defineTree } from './utils'

export default (clientHttp) => ({
  async getAll({ fields, id }) {
    try {
      const res = await getDestinations({
        clientHttp,
        fields,
        id,
        params: { page: 'all' },
      })
      const response = res?.data

      return response
    } catch (err) {
      console.error(err)

      throw err
    }
  },
  async getTree({ id }) {
    const includes = ['country', 'cluster']

    try {
      const res = await getDestinations({
        clientHttp,
        id,
        includes,
      })
      const response = res?.data
      const destinations = res?.included?.destinations
      // Define tree
      const { cluster, country, desti } = defineTree(response, destinations)

      return [
        {
          name: desti?.name,
          slug: desti?.slug,
          searchUrl: desti?.searchUrl,
        },
        {
          name: cluster?.name,
          slug: cluster?.slug,
          searchUrl: cluster?.searchUrl,
        },
        {
          name: country?.name,
          slug: country?.slug,
          searchUrl: country?.searchUrl,
        },
      ].filter((x) => x.name !== undefined)
    } catch (err) {
      console.error(err)

      throw err
    }
  },
  /**
   *
   * @param {{ slug: String }} param0
   * @returns {Promise<Partial<Record<'cluster' | 'country' | 'desti', import('lc-repository/dist/entities').Destination}>>>}
   */
  async getAncestries({ slug }) {
    const includes = ['country', 'cluster']
    const fields = {
      destination: ['cluster', 'country', 'isCluster', 'isCountry', 'name'],
    }

    try {
      const res = await getDestinations({
        clientHttp,
        slug,
        includes,
        fields,
      })

      const response = res?.data
      const destinations = Array.isArray(res?.included?.destinations)
        ? res?.included?.destinations
        : [{ ...res?.included?.destinations }]

      const { cluster, country, desti } = defineTree(response, destinations)

      return { cluster, country, desti }
    } catch (err) {
      console.error(err)

      throw err
    }
  },
  /**
   * @param {{ id?: String | String[] | Number | Number[]; fields?: Record<string, any>; slug?: String; params?: Record<string, any>}} param0
   */
  async getPhoto({ id, fields = {}, slug = '', params = {} }) {
    try {
      const includes = [
        'cluster.cover_featured_photo',
        'cluster',
        'country.cover_featured_photo',
        'country',
        'cover_featured_photo',
        'seo_featured_photo',
      ]
      const res = await getDestinations({
        clientHttp,
        fields,
        id,
        includes,
        params,
        slug,
      })
      const response = res?.data
      const destinations = res?.included?.destinations
      const photos = res?.included?.photos

      if (Array.isArray(response)) {
        return response.map((d) => {
          return addPhotosToDestination(d, photos, destinations)
        })
      } else {
        return addPhotosToDestination(response, photos, destinations)
      }
    } catch (err) {
      console.error(err)

      throw err
    }
  },
  /**
   * @param {{ id?: String; fields?: Record<string, any>; slug?: String; params?: Record<string, any>}} param0
   */
  async getPhotoAndAncestries({ id, fields, slug, params }) {
    try {
      const includes = [
        'cluster.cover_featured_photo',
        'cluster',
        'country.cover_featured_photo',
        'country',
        'cover_featured_photo',
        'seo_featured_photo',
      ]
      const res = await getDestinations({
        clientHttp,
        fields,
        id,
        includes,
        params,
        slug,
      })
      const response = res?.data
      const photos = res?.included?.photos
      const destinations = Array.isArray(res?.included?.destinations)
        ? res?.included?.destinations
        : [{ ...res?.included?.destinations }]

      const { cluster, country, desti } = defineTree(response, destinations)

      if (Array.isArray(response)) {
        return {
          destinations: [
            ...response.map((d) => {
              return addPhotosToDestination(
                d,
                photos,
                res?.included?.destinations,
              )
            }),
          ],
          cluster,
          country,
          desti,
        }
      } else {
        return {
          ...addPhotosToDestination(
            response,
            photos,
            res?.included?.destinations,
          ),
          cluster,
          country,
          desti,
        }
      }
    } catch (err) {
      console.error(err)

      throw err
    }
  },
  /**
   *
   * @param {{ slug: String, fields: Record<string, any>, includes?: String[], params?: Record<string, any> }} param0
   * @returns {Promise<any>}
   */
  async getOneBySlug({ slug, fields, includes, params }) {
    const res = await getDestinations({
      clientHttp,
      fields,
      includes,
      params,
      slug,
    })

    return res
  },
  async getById({ id, fields = {}, includes = [], params = {} }) {
    const res = await getDestinations({
      clientHttp,
      fields,
      id,
      includes,
      params,
    })

    return res
  },
})
